
























import { Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import PlanLimitsMixin from '@/components/ui/mixins/plan-limits-mixin';

@Component
export default class Crawler extends mixins(PlanLimitsMixin) {
  @Prop() conditions: any;
  value: string = 'IS_NOT_CRAWLER';
  predicate: string = 'EQUALS';

  @Watch('conditions', {
    immediate: true
  })
  onConditionsChanged(value: any) {
    if(!value.crawler) {
      this.$set(this.conditions, 'crawler', {
        predicate: 'EQUALS',
        values: 'IS_NOT_CRAWLER'
      });
    }
  }

  @Watch('value')
  onValueChanged(value: string) {
    this.$set(this.conditions.crawler, 'values', value);
  }

  @Watch('predicate')
  onPredicateChanged(value: string) {
    this.$set(this.conditions.crawler, 'predicate', value);
  }

  mounted() {
    this.value = this.conditions.crawler.values;
  }
}
